/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
export const sectionGrid = {
  default: "grid-col-2-10",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-2-10 grid-row-1-2",
  "headline-hero-priority": "grid-col-3-13 grid-row-1-2",
  "headline-sideway": "grid-col-2-8 grid-row-m-1-2 grid-row-2-3",
  "hero-overlay": "grid-col-3-13 grid-row-2-3 grid-col-1-2"
};

export const headlineGrid = {
  default: "grid-col-2-10 ",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-2-10 grid-row-2-3",
  "headline-hero-priority": "grid-col-3-13 grid-row-2-3 ",
  "headline-sideway": "grid-col-2-8 grid-row-3-4 grid-row-m-2-3 grid-row-3-4",
  "hero-overlay": "grid-col-3-13 grid-row-3-4 grid-col-1-2"
};

export const subheadlineGrid = {
  default: "grid-col-2-10 ",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-2-10 grid-row-3-4",
  "headline-hero-priority": "grid-col-3-13 grid-row-3-4",
  "headline-sideway": "grid-col-2-8 grid-row-m-3-4 grid-row-4-5",
  "hero-overlay": "grid-col-3-13 grid-row-4-5 grid-col-1-2"
};

export const amazonPollyGrid = {
  default: "grid-col-2-10 ",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-2-10 grid-row-4-5",
  "headline-hero-priority": "grid-col-3-13 grid-row-4-5",
  "headline-sideway": "grid-col-2-8 grid-row-m-4-5 grid-row-5-6",
  "hero-overlay": "grid-col-3-13 grid-row-5-6 grid-col-1-2"
};

export const imageGrid = {
  default: "grid-col-1-15",
  "hero-priority": "grid-col-2-14",
  "headline-priority": "grid-col-2-10",
  "headline-hero-priority": "grid-col-2-14",
  "headline-sideway": "grid-col-8-15 grid-row-1-8",
  "hero-overlay": "grid-col-2-14 grid-row-1-8 grid-col-1-2"
};

export const imageCaptionGrid = {
  default: "grid-col-2-14",
  "hero-priority": "grid-col-2-14",
  "headline-priority": "grid-col-2-10",
  "headline-hero-priority": "grid-col-2-14",
  "headline-sideway": "grid-col-8-15 grid-row-8-9",
  "hero-overlay": "grid-col-2-14 grid-row-8-9 grid-col-1-2"
};

export const authorGrid = {
  default: "grid-col-2-7",
  "hero-priority": "grid-col-4-8",
  "headline-priority": "grid-col-3-8",
  "headline-hero-priority": "grid-col-4-9",
  "headline-sideway": "grid-col-2-8  grid-row-m-5-6 grid-row-6-7",
  "hero-overlay": "grid-col-3-13 grid-row-6-7  grid-col-1-2"
};

export const horizontalLineGrid = {
  default: "grid-col-2-10"
};

export const relatedStoriesGrid = {
  default: "grid-col-10-14 grid-row-3-12",
  "hero-priority": "grid-col-2-14",
  "headline-priority": "grid-col-10-14 grid-row-1-13",
  "headline-hero-priority": "grid-col-2-14",
  "headline-sideway": "grid-col-2-14",
  "hero-overlay": "grid-col-2-14 grid-col-1-2"
};

export const socialTagsGrid = {
  default: "grid-col-2-10",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-4-12",
  "headline-hero-priority": "grid-col-4-12",
  "headline-sideway": "grid-col-4-12",
  "hero-overlay": "grid-col-4-12 grid-col-1-2"
};

export const metypeGrid = {
  default: "grid-col-2-10",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-4-12",
  "headline-hero-priority": "grid-col-4-12",
  "headline-sideway": "grid-col-4-12",
  "hero-overlay": "grid-col-4-12 grid-col-1-2"
};
